(() => {
  const body = document.body;

  const openDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    drawer?.classList.add('open');
    drawer?.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    body.classList.add('drawer-open');
  };

  const closeDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    drawer?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    body.classList.remove('drawer-open');
  };

  const replaceFromHtml = (html, selector) => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(selector);
    const current = document.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
  };

  const updateCount = async () => {
    const cart = await fetch('/cart.js').then((response) => response.json());
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
    return cart;
  };

  const changeQuantity = async (key, quantity, source) => {
    const surface = source.closest('[data-cart-drawer], [data-cart-page]');
    surface?.classList.add('is-updating');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: key, quantity: Math.max(0, quantity)})
      });
      if (!response.ok) throw new Error('Winkelwagen kon niet worden bijgewerkt');
      await updateCount();
      const html = await fetch(location.pathname + location.search).then((result) => result.text());
      if (document.querySelector('[data-cart-page]')) replaceFromHtml(html, '[data-cart-page]');
      replaceFromHtml(html, '[data-cart-drawer]');
      if (!document.querySelector('[data-cart-page]')) openDrawer();
    } catch (error) {
      const status = surface?.querySelector('[data-cart-status]') || document.querySelector('[data-cart-status]');
      if (status) {
        status.textContent = error.message;
        status.hidden = false;
        window.setTimeout(() => { status.hidden = true; }, 3000);
      }
      surface?.classList.remove('is-updating');
    }
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer();
      return;
    }
    const close = event.target.closest('[data-cart-close], [data-cart-overlay]');
    if (close) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer();
      return;
    }
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      event.preventDefault();
      changeQuantity(quantity.dataset.key, Number(quantity.dataset.quantity), quantity);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('[data-cart-drawer].open')) closeDrawer();
  });
})();
